import { IRouteProps } from 'IRoute'

import permissions from '../../commons/constants/permissions'
import { List, Show, Print } from '../../pages/Complaint'

const path = 'complaint'

const route:IRouteProps[] = [
  {
    path: `/${path}`,
    component: List,
    roles: [permissions.COMPLAINTS_ACCESS, permissions.COMPLAINTS_LIST]
  },
  {
    path: `/${path}/:id`,
    component: Show,
    roles: [permissions.COMPLAINTS_ACCESS]
  },
  {
    path: `/${path}/:id/print`,
    component: Print,
    roles: [permissions.COMPLAINTS_ACCESS]
  }
]

export default route
